export default {
  openedSessionIdList: [],
  sessionList: [],
  sessionLastRouteHistory: {},
}
